import Select from "react-select";
import { FileUploader } from "react-drag-drop-files";
import { toast } from "react-hot-toast";
import { readImageFile } from "../../../utils/helpers/imageUpload";
import { resolveAssetUrl } from "../../../utils/helpers/storeSetting";
import { useMemo, useRef } from "react";
import { FieldFeedback, FormValidationNotice, RequiredMark } from "../../../components/FormValidation";
import useFormValidation from "../../../hooks/useFormValidation";
import { validationRules as rule } from "../../../utils/helpers/formValidation";

const FormSupplier = (props) => {
  const {
    isShowModal: _isShowModal,
    isEdit,
    closeModal,
    formState,
    setFormState,
    handleAdd,
    handleUpdate,
    cities,
    isLoading = false,
  } = props;
  const formRef = useRef(null);
  const validationSchema = useMemo(() => ({
    name: rule.required("Nama supplier wajib diisi."),
    email: rule.email(),
    phone: rule.phone(),
    category: [rule.required("Kategori supplier wajib dipilih."), rule.oneOf(["personal", "business", "other"])],
  }), []);
  const validation = useFormValidation({ values: formState, schema: validationSchema, formId: "supplier", focusRoot: formRef });

  const submit = async (handler) => {
    if (!validation.validateAll() || isLoading) return;
    await handler();
  };

  const optionCities = (cities || []).map((city) => {
    return {
      value: city?.id,
      label: city?.name,
    };
  });
  const optionCategory = [
    { value: "personal", label: "Perorangan" },
    { value: "business", label: "Bisnis" },
    { value: "other", label: "Lainnya" },
  ];

  const optionBank = [
    { value: "BCA", label: "BCA" },
    { value: "MANDIRI", label: "Mandiri" },
    { value: "BNI", label: "BNI" },
    { value: "BRI", label: "BRI" },
    { value: "CIMB", label: "CIMB" },
    { value: "PERMATA", label: "Permata" },
    { value: "BSI", label: "BSI" },
    { value: "BTN", label: "BTN" },
    { value: "BJB", label: "BJB" },
    { value: "BTPN", label: "BTPN" },
    { value: "PANIN", label: "Panin" },
    { value: "OCBC", label: "OCBC" },
    { value: "UOB", label: "UOB" },
    { value: "MNC", label: "MNC" },
    { value: "MAYBANK", label: "Maybank" },
    { value: "BANK JAGO", label: "Bank Jago" },
    { value: "BANK MEGA", label: "Bank Mega" },
    { value: "BANK SINARMAS", label: "Bank Sinarmas" },
    { value: "BANK DANAMON", label: "Bank Danamon" },
    { value: "BANK BTPN", label: "Bank BTPN" },
  ];

  return (
    <div
      className="modal modal-blur fade "
      id="modal-form"
      tabIndex="-1"
      role="dialog"
      aria-hidden="false"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.3)",
      }}>
      <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div ref={formRef} className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Master Supplier {!isEdit ? "Baru" : "Edit"}</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={closeModal}></button>
          </div>
          <div className="modal-body">
            <FormValidationNotice errors={validation.errors} />
            <div className="row">
              <div className="col-lg-12">
                <label className="form-label">Nama Lengkap<RequiredMark /></label>
                <div className="mb-3 input-icon">
                  <span className="input-icon-addon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="icon icon-1">
                      <path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"></path>
                      <path d="M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"></path>
                    </svg>
                  </span>
                  <input
                    {...validation.fieldProps("name")}
                    type="text"
                    className={validation.inputClass("name")}
                    placeholder="nama lengkap"
                    value={formState?.name || ""}
                    onChange={(e) =>
                      setFormState((prev) => ({
                        ...prev,
                        name: e.target.value,
                      }))
                    }
                  />
                  <FieldFeedback formId="supplier" name="name" error={validation.errors.name} hint="Nama supplier akan tampil pada pembelian dan laporan hutang." />
                </div>
              </div>
              <div className="col-lg-12">
                <div className="row">
                  <div className="col-lg-6">
                    <label className="form-label">Email<RequiredMark optional /></label>
                    <div className="mb-3 input-icon">
                      <span className="input-icon-addon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="icon icon-1">
                          <path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"></path>
                          <path d="M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"></path>
                        </svg>
                      </span>
                      <input
                        {...validation.fieldProps("email")}
                        type="email"
                        className={validation.inputClass("email")}
                        placeholder="email"
                        value={formState?.email || ""}
                        onChange={(e) =>
                          setFormState((prev) => ({
                            ...prev,
                            email: e.target.value,
                          }))
                        }
                      />
                      <FieldFeedback formId="supplier" name="email" error={validation.errors.email} hint="Jika diisi, gunakan email valid yang belum dipakai supplier lain." />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <label className="form-label">No HP<RequiredMark optional /></label>
                    <div className="mb-3 input-icon">
                      <span className="input-icon-addon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="icon icon-1">
                          <path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"></path>
                          <path d="M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"></path>
                        </svg>
                      </span>
                      <input
                        {...validation.fieldProps("phone")}
                        type="text"
                        className={validation.inputClass("phone")}
                        placeholder="no hp"
                        value={formState?.phone || ""}
                        onChange={(e) =>
                          setFormState((prev) => ({
                            ...prev,
                            phone: e.target.value.replace(/\D/g, "").slice(0, 15),
                          }))
                        }
                      />
                      <FieldFeedback formId="supplier" name="phone" error={validation.errors.phone} hint="Gunakan 8–15 digit angka tanpa spasi." />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-12">
                <div className="row">
                  <div className="col-lg-6" style={{ display: optionCities.length > 0 ? undefined : "none" }}>
                    <label className="form-label">Asal Kota</label>
                    <div className="mb-3 input-icon">
                      <span
                        className="input-icon-addon"
                        style={{
                          zIndex: 1,
                        }}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="icon icon-tabler icons-tabler-outline icon-tabler-map-2">
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M12 18.5l-3 -1.5l-6 3v-13l6 -3l6 3l6 -3v7.5" />
                          <path d="M9 4v13" />
                          <path d="M15 7v5.5" />
                          <path d="M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879" />
                          <path d="M19 18v.01" />
                        </svg>
                      </span>
                      <Select
                        options={optionCities || []}
                        name="roles"
                        className="form-select p-0"
                        classNamePrefix="akas-select"
                        styles={{
                          control: (base) => ({
                            ...base,
                            paddingLeft: "2rem", // beri ruang untuk ikon
                            border: "none",
                            borderRadius: "8px",
                            boxShadow: "none",
                            minHeight: "38px",
                            "&:hover": {
                              border: "none",
                              boxShadow: "none",
                            },
                          }),
                          multiValue: (base) => ({
                            ...base,
                            backgroundColor: "#e3f2fd", // soft light blue
                            borderRadius: "20px",
                            padding: "2px 8px",
                          }),
                          multiValueLabel: (base) => ({
                            ...base,
                            color: "#a7f3d0", // soft blue text
                            fontWeight: "500",
                          }),
                          multiValueRemove: (base) => ({
                            ...base,
                            color: "#a7f3d0",
                            ":hover": {
                              backgroundColor: "#bbdefb", // hover soft blue
                              color: "#a7f3d0",
                            },
                          }),
                          // list dropdown style
                          menu: (base) => ({
                            ...base,
                            zIndex: 2,
                          }),
                          placeholder: (base) => ({
                            ...base,
                            color: "#90a4ae", // muted blue-gray
                          }),
                          option: (base, state) => ({
                            ...base,
                            backgroundColor: state.isSelected
                              ? "#32CD32" // item yang dipilih
                              : state.isFocused
                                ? "#90EE90" // saat hover
                                : "#FFF", // default
                            color: state.isSelected
                              ? "#FFF" // item yang dipilih
                              : state.isFocused
                                ? "#000" // saat hover
                                : "#000", // default
                            cursor: "pointer",
                          }),
                        }}
                        value={
                          formState?.city_id ? optionCities.find((option) => option.value === formState?.city_id) : null
                        }
                        onChange={(selectedOptions) => {
                          setFormState({
                            ...formState,
                            city_id: selectedOptions?.value || "",
                            city_name: selectedOptions?.label || "",
                          });
                        }}
                        placeholder="-- Pilih Kota --"
                      />
                    </div>
                  </div>
                  <div className={optionCities.length > 0 ? "col-lg-6" : "col-lg-12"}>
                    <label className="form-label">Alamat</label>
                    <div className="mb-3 input-icon">
                      <span className="input-icon-addon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="icon icon-tabler icons-tabler-outline icon-tabler-map-2">
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M12 18.5l-3 -1.5l-6 3v-13l6 -3l6 3l6 -3v7.5" />
                          <path d="M9 4v13" />
                          <path d="M15 7v5.5" />
                          <path d="M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879" />
                          <path d="M19 18v.01" />
                        </svg>
                      </span>
                      <input
                        type="text"
                        className="form-control"
                        name="address"
                        placeholder="alamat"
                        value={formState?.address || ""}
                        onChange={(e) =>
                          setFormState((prev) => ({
                            ...prev,
                            address: e.target.value,
                          }))
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-12">
                <div className="row">
                  <div className="col-lg-6">
                    <label className="form-label">Kategori<RequiredMark /></label>
                    <div className="mb-3 input-icon">
                      <span
                        className="input-icon-addon"
                        style={{
                          zIndex: 9999,
                        }}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="icon icon-tabler icons-tabler-outline icon-tabler-category">
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M4 4h6v6h-6l0 -6" />
                          <path d="M14 4h6v6h-6l0 -6" />
                          <path d="M4 14h6v6h-6l0 -6" />
                          <path d="M14 17a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
                        </svg>
                      </span>
                      <Select
                        {...validation.fieldProps("category")}
                        data-validation-field="category"
                        options={optionCategory || []}
                        name="category"
                        className={validation.inputClass("category", "form-select p-0")}
                        classNamePrefix="akas-select"
                        styles={{
                          control: (base) => ({
                            ...base,
                            paddingLeft: "2rem", // beri ruang untuk ikon
                            border: "none",
                            borderRadius: "8px",
                            boxShadow: "none",
                            minHeight: "38px",
                            "&:hover": {
                              border: "none",
                              boxShadow: "none",
                            },
                          }),
                          multiValue: (base) => ({
                            ...base,
                            backgroundColor: "#e3f2fd", // soft light blue
                            borderRadius: "20px",
                            padding: "2px 8px",
                          }),
                          multiValueLabel: (base) => ({
                            ...base,
                            color: "#a7f3d0", // soft blue text
                            fontWeight: "500",
                          }),
                          multiValueRemove: (base) => ({
                            ...base,
                            color: "#a7f3d0",
                            ":hover": {
                              backgroundColor: "#bbdefb", // hover soft blue
                              color: "#a7f3d0",
                            },
                          }),
                          // list dropdown style
                          menu: (base) => ({
                            ...base,
                            zIndex: 2,
                          }),
                          placeholder: (base) => ({
                            ...base,
                            color: "#90a4ae", // muted blue-gray
                          }),
                          option: (base, state) => ({
                            ...base,
                            backgroundColor: state.isSelected
                              ? "#32CD32" // item yang dipilih
                              : state.isFocused
                                ? "#90EE90" // saat hover
                                : "#FFF", // default
                            color: state.isSelected
                              ? "#FFF" // item yang dipilih
                              : state.isFocused
                                ? "#000" // saat hover
                                : "#000", // default
                            cursor: "pointer",
                          }),
                        }}
                        value={
                          formState?.category
                            ? optionCategory.find((option) => option.value === formState?.category)
                            : null
                        }
                        onChange={(selectedOptions) => {
                          setFormState({
                            ...formState,
                            category: selectedOptions?.value || "",
                            category_name: selectedOptions?.label || "",
                          });
                        }}
                        placeholder="-- Pilih Kategori --"
                      />
                      <FieldFeedback formId="supplier" name="category" error={validation.errors.category} hint="Pilih Perorangan, Bisnis, atau Lainnya." />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <label className="form-label">Nama Toko</label>
                    <div className="mb-3 input-icon">
                      <span className="input-icon-addon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="icon icon-tabler icons-tabler-outline icon-tabler-building-store">
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M3 21l18 0" />
                          <path d="M3 7v1a3 3 0 0 0 6 0v-1m0 1a3 3 0 0 0 6 0v-1m0 1a3 3 0 0 0 6 0v-1h-18l2 -4h14l2 4" />
                          <path d="M5 21l0 -10.15" />
                          <path d="M19 21l0 -10.15" />
                          <path d="M9 21v-4a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v4" />
                        </svg>
                      </span>
                      <input
                        type="text"
                        className="form-control"
                        name="shopname"
                        placeholder="nama toko"
                        value={formState?.shopname || ""}
                        onChange={(e) =>
                          setFormState((prev) => ({
                            ...prev,
                            shopname: e.target.value,
                          }))
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-12">
                <div className="row">
                  <div className="col-lg-3">
                    <label className="form-label">Bank</label>
                    <div className="mb-3 input-icon">
                      <span
                        className="input-icon-addon"
                        style={{
                          zIndex: 1,
                        }}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="icon icon-tabler icons-tabler-outline icon-tabler-building">
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M3 21l18 0" />
                          <path d="M9 8l1 0" />
                          <path d="M9 12l1 0" />
                          <path d="M9 16l1 0" />
                          <path d="M14 8l1 0" />
                          <path d="M14 12l1 0" />
                          <path d="M14 16l1 0" />
                          <path d="M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16" />
                        </svg>
                      </span>
                      <Select
                        options={optionBank || []}
                        name="roles"
                        className="form-select p-0"
                        classNamePrefix="akas-select"
                        styles={{
                          control: (base) => ({
                            ...base,
                            paddingLeft: "2rem", // beri ruang untuk ikon
                            border: "none",
                            borderRadius: "8px",
                            boxShadow: "none",
                            minHeight: "38px",
                            "&:hover": {
                              border: "none",
                              boxShadow: "none",
                            },
                          }),
                          multiValue: (base) => ({
                            ...base,
                            backgroundColor: "#e3f2fd", // soft light blue
                            borderRadius: "20px",
                            padding: "2px 8px",
                          }),
                          multiValueLabel: (base) => ({
                            ...base,
                            color: "#a7f3d0", // soft blue text
                            fontWeight: "500",
                          }),
                          multiValueRemove: (base) => ({
                            ...base,
                            color: "#a7f3d0",
                            ":hover": {
                              backgroundColor: "#bbdefb", // hover soft blue
                              color: "#a7f3d0",
                            },
                          }),
                          // list dropdown style
                          menu: (base) => ({
                            ...base,
                            zIndex: 2,
                          }),
                          placeholder: (base) => ({
                            ...base,
                            color: "#90a4ae", // muted blue-gray
                          }),
                          option: (base, state) => ({
                            ...base,
                            backgroundColor: state.isSelected
                              ? "#32CD32" // item yang dipilih
                              : state.isFocused
                                ? "#90EE90" // saat hover
                                : "#FFF", // default
                            color: state.isSelected
                              ? "#FFF" // item yang dipilih
                              : state.isFocused
                                ? "#000" // saat hover
                                : "#000", // default
                            cursor: "pointer",
                          }),
                        }}
                        value={
                          formState?.bank_name
                            ? optionBank.find((option) => option.value === formState?.bank_name)
                            : null
                        }
                        onChange={(selectedOptions) => {
                          setFormState({
                            ...formState,
                            bank_name: selectedOptions?.value || "",
                          });
                        }}
                        placeholder="- Bank -"
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <label className="form-label">Nama Rekening</label>
                    <div className="mb-3 input-icon">
                      <span className="input-icon-addon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="icon icon-1">
                          <path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"></path>
                          <path d="M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"></path>
                        </svg>
                      </span>
                      <input
                        type="text"
                        className="form-control"
                        name="account_holder"
                        placeholder="nama pemegang rekening"
                        value={formState?.account_holder || ""}
                        onChange={(e) =>
                          setFormState((prev) => ({
                            ...prev,
                            account_holder: e.target.value,
                          }))
                        }
                      />
                    </div>
                  </div>
                  <div className="col-lg-5">
                    <label className="form-label">No. Rekening</label>
                    <div className="mb-3 input-icon">
                      <span className="input-icon-addon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="icon icon-tabler icons-tabler-outline icon-tabler-credit-card">
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <path d="M3 8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3l0 -8" />
                          <path d="M3 10l18 0" />
                          <path d="M7 15l.01 0" />
                          <path d="M11 15l2 0" />
                        </svg>
                      </span>
                      <input
                        type="text"
                        className="form-control"
                        name="account_number"
                        placeholder="nomor rekening"
                        value={formState?.account_number || ""}
                        onChange={(e) =>
                          setFormState((prev) => ({
                            ...prev,
                            account_number: e.target.value,
                          }))
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-12">
                <label className="form-label">Foto Profil</label>
                <div className="mb-3 w-100 ">
                  <div className="card  d-flex justify-content-center align-content-center w-100">
                    <DragDropFile setFormState={setFormState} formState={formState} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-link link-secondary btn-3"
              data-bs-dismiss="modal"
              onClick={closeModal}>
              Batal
            </button>
            {isEdit ? (
              <button
                type="button"
                className="btn btn-primary btn-5 ms-auto"
                disabled={isLoading}
                onClick={() => submit(handleUpdate)}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon icon-tabler icons-tabler-outline icon-tabler-edit">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1" />
                  <path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z" />
                  <path d="M16 5l3 3" />
                </svg>
                {isLoading ? "Menyimpan..." : "Simpan Perubahan"}
              </button>
            ) : (
              <button
                type="button"
                className="btn btn-primary btn-5 ms-auto"
                disabled={isLoading}
                onClick={() => submit(handleAdd)}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon icon-2">
                  <path d="M12 5l0 14" />
                  <path d="M5 12l14 0" />
                </svg>
                {isLoading ? "Menyimpan..." : "Tambah Supplier"}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
const DragDropFile = (props) => {
  const { setFormState, formState } = props;
  const fileTypes = ["JPG", "JPEG", "PNG", "WEBP"];

  return (
    <FileUploader
      multiple={false}
      handleChange={async (file) => {
        try {
          const base64 = await readImageFile(file, { label: "Foto supplier", preset: "avatar" });
          setFormState((previous) => ({
            ...previous,
            image: base64,
            image_path: base64,
            imageUrl: base64,
            file_name: file?.name,
          }));
        } catch (error) {
          toast.error(error?.message || "Foto supplier tidak dapat dibaca.");
        }
      }}
      name="file"
      types={fileTypes}
      dropMessageStyle={{ margin: "0  0.5rem" }}
      style={{ position: "relative" }}>
      <div className="d-flex align-items-center justify-content-center w-100 ">
        <label
          htmlFor="dropzone-file"
          className="d-flex flex-column align-items-center justify-content-center w-100  rounded cursor-pointer bg-light"
          style={{ height: "16rem" }}>
          <div className="d-flex flex-column align-items-center justify-content-center pt-3 pb-3">
            <svg
              className="mb-3 text-secondary"
              width="32"
              height="32"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 20 16">
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
              />
            </svg>
            <p className="mb-2 text-muted small">
              <strong>Click Untuk upload</strong> atau drag and drop
            </p>
            <p className="text-muted small">JPG, PNG, atau WEBP (maks. 5 MB, dioptimalkan otomatis)</p>
          </div>
        </label>
      </div>

      {formState?.image_path || formState?.image || formState?.imageUrl ? (
        <div
          className="d-flex align-items-center justify-content-center w-100 position-absolute bottom-0 z-0 border border-primary rounded transition-opacity"
          style={{
            height: "16rem",
            opacity: "1",
          }}
          onMouseOver={(e) => (e.currentTarget.style.opacity = "0.5")}
          onMouseOut={(e) => (e.currentTarget.style.opacity = "1")}>
          <img
            src={resolveAssetUrl(formState?.imageUrl || formState?.image_path || formState?.image, "")}
            className="rounded h-100 w-100 p-2 object-fit-contain"
            alt="Uploaded preview"
          />
        </div>
      ) : (
        ""
      )}
    </FileUploader>
  );
};

export default FormSupplier;
